/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IntervalUnit {
    Days = 0,
    Hours = 1,
    Minutes = 2,
    Months = 3,
    Seconds = 4,
    Weekdays = 5,
    Weeks = 6,
    Years = 7,
    Milliseconds = 8,
}
